import { defineTextStyles } from '@chakra-ui/react'

// Text style overrides, keyed like src/theme/text-styles.ts.
export const textStyles = defineTextStyles({
  // Graded tracking instead of -0.05em at every size from lg up.
  lg: { value: { letterSpacing: '-0.01em' } },
  xl: { value: { letterSpacing: '-0.02em' } },
  '2xl': { value: { letterSpacing: '-0.025em' } },
  '3xl': { value: { letterSpacing: '-0.03em' } },
  '4xl': { value: { letterSpacing: '-0.035em' } },
  '5xl': { value: { letterSpacing: '-0.04em' } },
  '6xl': { value: { letterSpacing: '-0.04em' } },
  '7xl': { value: { letterSpacing: '-0.04em' } },
  // Eyebrows and labels: medium weight, sentence case, no letter-spacing (the mockups' .eyebrow).
  // Pair with fg.muted where they sit.
  label: { value: { fontWeight: 'medium', textTransform: 'none', letterSpacing: '0' } },
  labelXs: { value: { fontWeight: 'medium', textTransform: 'none', letterSpacing: '0' } },
  label2xs: { value: { fontWeight: 'medium', textTransform: 'none', letterSpacing: '0' } },
})
